import { ComponentType as l } from "../../registries/types/propTypes.js";
const u = (i) => {
  const o = Array.isArray(i.quick_links_design_two) ? i.quick_links_design_two[0] : i.quick_links_design_two, { display_title: e, quick_links: s } = o || {}, t = [];
  return s == null || s.map((n) => {
    const k = { url: n.image.url }, r = { url: n.links.url, text: n.links.text, target: n.links.target };
    t.push({
      imagedata: k,
      linkdata: r
    });
  }), {
    componentType: l.quick_links_design_two,
    title: e,
    quickLinks: t
  };
};
export {
  u as default
};
//# sourceMappingURL=quickLinksDesignTwoTransformer.js.map
